import React from 'react';
import logoImage from '../../images/ABTSource logo Transparent.png';
import '../../styles/components/common/Logo.css';

/**
 * Logo component that can be used throughout the application
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.size - Size variant ('small', 'medium', 'large')
 * @param {boolean} props.showSubtitle - Whether to show subtitle text
 * @returns {JSX.Element} Logo component
 */
const Logo = ({ className = '', size = 'medium', showSubtitle = false }) => {
  const sizeClasses = {
    small: 'logo--small',
    medium: 'logo--medium', 
    large: 'logo--large'
  };

  return (
    <div className={`logo ${sizeClasses[size]} ${className}`}>
      <img 
        src={logoImage} 
        alt="ABTSource Logo" 
        className="logo__image"
      />
      {showSubtitle && (
        <span className="logo__subtitle">Portfolio Management System</span>
      )}
    </div>
  );
};

export default Logo;
